export const right = {
    render: 'Right',
    children: ['paragraph', 'tag', 'list', 'fence'],
};
